import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  private http: HttpClient = inject(HttpClient);

  export(request: any, endpoint: string, format: 'pdf' | 'xlsx' | 'csv'): Promise<Blob> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/${endpoint}/export/${format}`, request, {
      responseType: 'blob'
    }));
  }
}
